module.exports = __webpack_public_path__ + "img/4.b258a272.png";